import React from 'react';
import * as automateBusinessStyle from "./automateBusiness.module.scss";
import ButtonLink from "../../common/buttonLink/buttonLink";
import {getRedirectionLink, pushToDataLayer} from "../../../utils/redirectToTryForFree";

function AutomateBusiness () {
  return (
    <div className={automateBusinessStyle.automateWrapper}>
      <div className={automateBusinessStyle.automateWrapper__automate}>
        <div className={automateBusinessStyle.automateWrapper__automate__text}>
          <h2 className={automateBusinessStyle.automateWrapper__automate__text__title}>
            Automate your business with Trafft for <span>FREE</span>
          </h2>
          <p className={automateBusinessStyle.automateWrapper__automate__text__description}>
            Trafft offers a forever-free plan that is perfect for teams of up to 5.  Get started and scale your business.
          </p>
        </div>
        <div className={automateBusinessStyle.automateWrapper__automate__btnDiv}>
          <ButtonLink
            href={getRedirectionLink()}
            onClick={pushToDataLayer}
            type='bck-transparent'
            label="Get started for free"
            target="_blank"
            extraClass='primary'
          />
        </div>
      </div>
    </div>
  )
}

export default AutomateBusiness